import i18next from 'i18next';

import { LANGUAGES } from 'src/packages/language/consts';

export function getLocale(): string {
  return i18next.language || LANGUAGES.ru;
}
